import { gsap } from 'gsap';
import { init, enter } from '../animations';

export function gameEnter(el) {
  const scoreBg = el.querySelector('.game-score__bg');
  const scoreMt = el.querySelector('.game-score__points');
  const powerup = el.querySelector('.game-progressbar');
  const circularLife = el.querySelector('.game-life__circle');
  const textLife = el.querySelector('.game-life__text');
  const tl = gsap.timeline();

  init.get('fade')(scoreBg, { x: 15 });
  init.get('fade')(scoreMt, { x: 15 });
  init.get('fade')(powerup, { x: -15 });
  init.get('buttonCircular')(circularLife);
  init.get('fade')(textLife);

  tl.addLabel('start')
    .add(enter.get('fade')(scoreBg, 0, 0.5), 'start')
    .add(enter.get('fade')(scoreMt, 0, 0.5), 'start+=0.3')
    .add(enter.get('fade')(powerup, 0, 0.5), 'start+=0.3')
    .add(enter.get('buttonCircular')(circularLife), 'start+=0.3')
    .add(enter.get('fade')(textLife, 0, 0.5), 'start+=0.4');

  return tl;
}

export function gameLeave(el) {
  const tl = gsap.timeline();

  tl.addLabel('start')
    .to(el, { opacity: 0, duration: 0.5, ease: 'power3.easeOut' });

  return tl;
}
